<div class="copyright-container">
  <div class="container">Direitos Autorais © 2026. Todos os direitos reservados.</div>
</div>
